import React from 'react';
import {
  AgnesModal,
  AgnesButton,
  AgnesInput,
  AgnesSelect,
  AgnesSelectTrigger,
  AgnesSelectValue,
  AgnesSelectContent,
  AgnesSelectItem,
} from '@agnes/ui';
import { useUsuariosStore } from '@/stores/useUsuariosStore';

const SELECT_TRIGGER = 'w-full';
const ROLES = ['SUPER_ADMINISTRADOR', 'ADMINISTRADOR', 'ANALISTA', 'USUARIO'];

type Usuario = any;

interface Props {
  open: boolean;
  onClose: () => void;
  usuario?: Usuario | null; // presente = edição
}

export default function UsuarioFormModal({ open, onClose, usuario }: Props) {
  const editando = Boolean(usuario);
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [role, setRole] = React.useState('USUARIO');

  React.useEffect(() => {
    setFirstName(usuario?.first_name ?? '');
    setLastName(usuario?.last_name ?? '');
    setEmail(usuario?.email ?? '');
    setUsername(usuario?.username ?? '');
    setPassword('');
    setRole(usuario?.roles?.[0]?.name ?? 'USUARIO');
  }, [usuario, open]);

  const podeSalvar = firstName && lastName && email && role && (editando || password.length >= 8);

  async function salvar() {
    if (editando) {
      await useUsuariosStore.getState().editar(usuario.id, {
        first_name: firstName,
        last_name: lastName,
        email,
        kc_role: role,
      });
    } else {
      await useUsuariosStore.getState().criar({
        first_name: firstName,
        last_name: lastName,
        email,
        username: username || email,
        password,
        kc_role: role,
      });
    }
    onClose();
  }

  return (
    <AgnesModal
      open={open}
      title={editando ? 'Editar usuário' : 'Novo usuário'}
      maxWidth="sm"
      onClose={onClose}
      footer={
        <div className="flex justify-end gap-3">
          <AgnesButton variant="text" onClick={onClose}>
            Cancelar
          </AgnesButton>
          <AgnesButton variant="primary" disabled={!podeSalvar} onClick={salvar}>
            Salvar
          </AgnesButton>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <AgnesInput
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="Nome *"
        />
        <AgnesInput
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          placeholder="Sobrenome *"
        />
        <AgnesInput
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail *"
        />
        <AgnesInput
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Usuário"
          disabled={editando}
        />
        {!editando && (
          <AgnesInput
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Senha * (mín. 8)"
          />
        )}
        <AgnesSelect value={role} onValueChange={setRole}>
          <AgnesSelectTrigger className={SELECT_TRIGGER}>
            <AgnesSelectValue placeholder="Perfil *" />
          </AgnesSelectTrigger>
          <AgnesSelectContent>
            {ROLES.map((r) => (
              <AgnesSelectItem key={r} value={r}>
                {r}
              </AgnesSelectItem>
            ))}
          </AgnesSelectContent>
        </AgnesSelect>
      </div>
    </AgnesModal>
  );
}
